// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SlideIn__wrapper___sNSFe","enter-left":"SlideIn__enter-left___2sIaq","enter-left-active":"SlideIn__enter-left-active___3C_ka","enter-right":"SlideIn__enter-right___21xvE","enter-right-active":"SlideIn__enter-right-active___3CZxu","enter-bottom":"SlideIn__enter-bottom___1qlec","enter-bottom-active":"SlideIn__enter-bottom-active___29Sds","enter-top":"SlideIn__enter-top___kp3eE","enter-top-active":"SlideIn__enter-top-active___3haOa","leave":"SlideIn__leave___2dbGc","leave-active":"SlideIn__leave-active___1f_2T"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Transitions/SlideIn.scss
// module id = 566
// module chunks = 0